module.exports = __webpack_public_path__ + "static/media/container-storage.9ba7a835.svg";